import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

/**
 * 「Need Help?」指向的地址。
 *
 * <p>2026-09-17 之前这个链接在三个地方各写各的，三处**没有一处是通的**：
 * `OnboardingSplitLayout` 里它是个 `<div>`（11 个页面点了没反应），
 * `PlanDetailsPage` 和 `BusinessInfoPage` 写的是 `href="/help"`，而路由表里从来没有
 * `/help` —— 末尾的 `path: '*'` 兜到 `NotFoundPage`，也就是点一下进 404。
 *
 * <p>地址收在这里而不是散在各处，是为了下次换地方只改一行，也不会再有人漏掉 `href`。
 */
export const NEED_HELP_URL = 'https://calendly.com/joanna-chu-yepai/30min';

/**
 * 右上角那个「Need Help?」。外链另开一页 —— 商家正走在注册/引导流程中间，把他原地
 * 导走等于让他重来一遍。
 *
 * <p>样式由调用方给：三处的定位和配色本来就不同（引导页是绝对定位的浅灰，另两处是
 * 行内的深灰）。这个组件只保证一件事 —— **它是个真链接，而且三处指向同一个地方**。
 */
export function NeedHelpLink({ className = '' }: { className?: string }) {
  return (
    <a
      href={NEED_HELP_URL}
      target="_blank"
      rel="noreferrer"
      className={`flex items-center gap-1.5 transition hover:text-[#6b33ff] ${className}`}
    >
      Need Help? <QuestionMarkCircleIcon className="h-4 w-4" />
    </a>
  );
}
